interface NotificationLike {
  metadata?: Record<string, unknown> | null;
}

const INTAKE_REQUESTS_VIEW_PERMISSION = 'intake-requests.view';
const CORRECTIVE_MAINTENANCE_VIEW_PERMISSION = 'corrective-maintenance.view';
const SYNDIC_AGENDA_VIEW_PERMISSION = 'social.manager-agenda.view';
const SERVICE_PROVIDER_AGENDA_PERMISSION = 'service-provider.agenda.access';

const SYNDIC_AGENDA_PATH = '/agenda-sindico';
const CORRECTIVE_MAINTENANCE_PATH = '/manutencao-corretiva/condominio';
const SERVICE_PROVIDER_AGENDA_PATH = '/prestador/agenda';

const MODULE_BY_TYPE: Record<string, { path: string; idKey: string }> = {
  CORRECTIVE_MAINTENANCE: { path: CORRECTIVE_MAINTENANCE_PATH, idKey: 'maintenanceId' },
  COMPLAINT: { path: '/social/reclamacoes---sugestoes', idKey: 'complaintId' },
  SUGGESTION: { path: '/social/sugestoes', idKey: 'suggestionId' },
  SECURITY_INCIDENT: { path: '/portaria-e-seguranca/ocorrencias-de-seguranca', idKey: 'incidentId' },
  LOST_FOUND: { path: '/portaria-e-seguranca/achados-e-perdidos', idKey: 'lostAndFoundId' },
};

function readString(metadata: Record<string, unknown>, key: string): string | null {
  const value = metadata[key];
  return typeof value === 'string' && value.length > 0 ? value : null;
}

/**
 * Rota de manutenção que o usuário consegue abrir. O prestador não tem a
 * Agenda do Síndico nem o módulo de corretiva (caía no 403): vai para a
 * própria agenda, onde a manutenção atribuída a ele aparece.
 */
function maintenancePath(
  preferredPath: string,
  preferredPermission: string,
  permissions: readonly string[],
): string {
  if (
    !permissions.includes(preferredPermission) &&
    permissions.includes(SERVICE_PROVIDER_AGENDA_PERMISSION)
  ) {
    return SERVICE_PROVIDER_AGENDA_PATH;
  }
  return preferredPath;
}

/** Destino ao clicar numa notificação do sino. */
export function getNotificationTargetPath(
  notification: NotificationLike,
  permissions: readonly string[],
): string | null {
  const syndicAgenda = () =>
    maintenancePath(SYNDIC_AGENDA_PATH, SYNDIC_AGENDA_VIEW_PERMISSION, permissions);
  const metadata = notification.metadata;
  if (!metadata || typeof metadata !== 'object') {
    return syndicAgenda();
  }
  const source = readString(metadata, 'source');
  if (!source) {
    return syndicAgenda();
  }

  if (source === 'WHATSAPP' || source === 'WHATSAPP_DUPLICATE') {
    const intakeRequestId = readString(metadata, 'intakeRequestId');
    if (intakeRequestId && permissions.includes(INTAKE_REQUESTS_VIEW_PERMISSION)) {
      return `/central-de-solicitacoes?id=${intakeRequestId}`;
    }
    const target = MODULE_BY_TYPE[readString(metadata, 'type') ?? ''];
    if (target) {
      const id = readString(metadata, target.idKey);
      return id ? `${target.path}?id=${id}` : target.path;
    }
    // Avisos antigos do WhatsApp (antes da Central) eram só de corretiva.
    return CORRECTIVE_MAINTENANCE_PATH;
  }

  if (source === 'CORRECTIVE_MAINTENANCE') {
    return maintenancePath(
      CORRECTIVE_MAINTENANCE_PATH,
      CORRECTIVE_MAINTENANCE_VIEW_PERMISSION,
      permissions,
    );
  }

  if (
    source === 'PREVENTIVE_MAINTENANCE' ||
    source === 'SYNDIC_AGENDA' ||
    source === 'SERVICE_PROVIDER_AGENDA'
  ) {
    return syndicAgenda();
  }

  return '/configuracoes/notificacoes-e-preferencias';
}
